<template>
  <!-- eslint-disable -->
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click="$router.go(-1)">Atras</b-button>
        <b-button variant="success" class="ml-2" @click="confirmObservation">Confirmar Observación</b-button>
      </b-col>
    </b-row>
    <b-row v-if="datosMov">
      <b-col sm="12">
        <b-card no-body header-bg-variant="dark">
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de Movimiento</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Destino: </strong>
                <p class="">{{ datosMov.establishmentDestiny.name }}</p>
              </b-col>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Origen: </strong>
                <p class="">{{ datosMov.establishmentOrigin.name }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong>Número de documento: </strong>
                <p class="">{{ datosMov.documentCode }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong>Transportado por: </strong>
                <p class="">{{ datosMov.userReceiver.fullname }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong v-if="datosMov.internalRecords[datosMov.internalRecords.length - 1].state === 'Observado'">Observacion realizada por: </strong>
                <strong v-else-if="datosMov.internalRecords[datosMov.internalRecords.length - 1].state === 'Aprobado'">Aprobado por: </strong>
                <p class="">{{ datosMov.internalRecords[datosMov.internalRecords.length - 1].userChanged.fullname }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles de Movimiento</h4>
          </b-card-header>
          <b-card-text class="">
            <b-table
              class="position-relative"
              :hover="true"
              :items="details"
              responsive
              :fields="fields"
              show-empty
              empty-text="No existen"
              @sort-changed="sortChanged"
            >
            <template #cell(transito)="row">
                <b-form-select
                  v-if="row.item.lastQty > row.item.qty"
                  v-model="row.item.locationQuantity"
                  :options="transitOptions"
                  size="sm"
                  class="mb-0"
                />
                <span v-else>No aplica</span>
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                    <b-form-select
                      v-model="showEntrie"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="entries"
                      @change="changeSizePage"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" class="mt-75" style="font-size: 12px">
                  <span> {{ totalElements }} Registros en total</span>
                </b-col>
                <!-- Pagination -->
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalElements"
                    :per-page="showEntrie"
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @change="cambioPagina"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import InternalMovement from '@/services/InternalMovement'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      datosMov: null,
      details: [],
      transitOptions: [
        { value: 1, text: "Tienda de Destino" },
        { value: 2, text: "Tienda de Origen" },
        { value: 3, text: "Perdido" },
      ],
      fields: [
        { key: 'autopart.uniqueCode', label: 'Código Único', sortable: true },
        { key: 'autopart.originalCode', label: 'Codigo Original', sortable: true },
        { key: 'autopart.alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'autopart.description', label: 'Descripción', sortable: false },
        { key: 'qty', label: 'Cantidad', sortable: false },
        { key: 'observation', label: 'Observación', sortable: false },
        { key: "transito", label: "Transito", sortable: false },
      ],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  mounted() {
    this.getData()
    console.log("DETALLE ENTRADA")
  },
  methods: {
    async getData() {
      const resp = await InternalMovement.getMovementObservation(this.$route.params.id, this.$store)
      if (resp && resp.data) { 
       console.log("RESPUESTA", resp.data)
       this.datosMov = resp.data.internalMovement 
       this.transitOptions = [
         { value: 1, text: this.datosMov.establishmentDestiny.name },
         { value: 2, text: this.datosMov.establishmentOrigin.name },
         { value: 3, text: "Perdido" },
       ];
      this.details = resp.data.internalDetail.map((detail) => ({
        ...detail,
        locationQuantity: null, 
      }));
      this.totalElements = this.details.length 
      } else {
        console.error("Error: Datos no encontrados.");
      }
    },

    confirmObservation() {
      const filteredAutoparts = this.details
          .filter((detail) => detail.lastQty > detail.qty && detail.locationQuantity !== null)
          .map((detail) => ({
            autopartId: detail.autopartId,
            qty: detail.qty,
            locationQty: detail.locationQuantity,
          }));

        if (filteredAutoparts.length === 0) {
          const payload = {
            establishmentOriginId: this.datosMov.establishmentOriginId,
            establishmentDestinyId: this.datosMov.establishmentDestinyId,
            description: this.datosMov.description,
            documentCode: this.datosMov.documentCode,
            state: "Aprobado",
            autoparts: [],
          };
          console.log("PAYLOAD: ", payload)
  
          InternalMovement.updateProcess(this.datosMov.id, payload, this.$store)  
          this.$bvToast.toast("Observaciones confirmadas con éxito.", {
            title: "Éxito",
            variant: "success",
            solid: true,
          });
           this.$router.go(-1);
        }

        const payload = {
          establishmentOriginId: this.datosMov.establishmentOriginId,
          establishmentDestinyId: this.datosMov.establishmentDestinyId,
          description: this.datosMov.description,
          documentCode: this.datosMov.documentCode,
          state: "Aprobado",
          autoparts: filteredAutoparts,
        };
        console.log("PAYLOAD: ", payload)

        InternalMovement.updateProcess(this.datosMov.id, payload, this.$store)
        .then(() => {
          this.$bvToast.toast("Observaciones confirmadas con éxito.", {
            title: "Éxito",
            variant: "success",
            solid: true,
          });
           this.$router.go(-1);
        })
        .catch((error) => {
          console.error("Error al confirmar observaciones:", error);
          this.$bvToast.toast("Error al confirmar observaciones.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
    },

    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      this.order = data.sortDesc ? 'desc' : 'asc'
    },
    back() {
      this.$router.push('/inventario/entrada/bandeja') 
    }
  }
}
</script>

<style></style>
